import { useBusinessInfo } from '~/lib/Queries';
import InfoMessageBlock from '~/components/InfoMessageBlock';
import { Link } from 'react-router-dom';
import { getBusinessUrl } from '~/lib/useBusinessNavigate';

const GateRequiresPaymentProcessor = ({
    children,
    className,
    extraMessage,
}) => {
    const { data: businessData } = useBusinessInfo();
    const canPay = !!businessData?.canPay;

    if (canPay && !children) return null;

    return (
        <div className={className}>
            {!canPay && (
                <InfoMessageBlock>
                    Please set up a payment processor under{' '}
                    <Link to={getBusinessUrl('/integrations/payments')}>
                        Integrations
                    </Link>{' '}
                    to accept payments online.
                    {!!extraMessage && (
                        <div className="mt-2">{extraMessage}</div>
                    )}
                </InfoMessageBlock>
            )}
            {canPay && children}
        </div>
    );
};

export default GateRequiresPaymentProcessor;
